import { useEffect } from 'react'

interface OriginalScrollStyles {
  bodyOverflow: string
  bodyOverscrollBehavior: string
  bodyPaddingRight: string
  documentOverflow: string
  documentOverscrollBehavior: string
}

let activeLocks = 0
let originalStyles: OriginalScrollStyles | null = null

function acquireBodyScrollLock(): () => void {
  if (typeof document === 'undefined') return () => {}

  if (activeLocks === 0) {
    const body = document.body
    const documentElement = document.documentElement
    originalStyles = {
      bodyOverflow: body.style.overflow,
      bodyOverscrollBehavior: body.style.overscrollBehavior,
      bodyPaddingRight: body.style.paddingRight,
      documentOverflow: documentElement.style.overflow,
      documentOverscrollBehavior: documentElement.style.overscrollBehavior,
    }

    // Compensa la scrollbar che scompare, così la pagina non salta orizzontalmente.
    const scrollbarWidth = Math.max(0, window.innerWidth - documentElement.clientWidth)
    if (scrollbarWidth > 0) {
      const currentPadding = Number.parseFloat(window.getComputedStyle(body).paddingRight) || 0
      body.style.paddingRight = `${currentPadding + scrollbarWidth}px`
    }

    body.style.overflow = 'hidden'
    body.style.overscrollBehavior = 'none'
    documentElement.style.overflow = 'hidden'
    documentElement.style.overscrollBehavior = 'none'
  }

  activeLocks += 1
  let released = false

  return () => {
    if (released) return
    released = true
    activeLocks = Math.max(0, activeLocks - 1)

    // Conferme e altre modali possono essere sovrapposte: sblocca solo alla chiusura dell'ultima.
    if (activeLocks !== 0 || !originalStyles || typeof document === 'undefined') return

    document.body.style.overflow = originalStyles.bodyOverflow
    document.body.style.overscrollBehavior = originalStyles.bodyOverscrollBehavior
    document.body.style.paddingRight = originalStyles.bodyPaddingRight
    document.documentElement.style.overflow = originalStyles.documentOverflow
    document.documentElement.style.overscrollBehavior = originalStyles.documentOverscrollBehavior
    originalStyles = null
  }
}

/** Blocca lo scroll del documento mentre almeno una modale è aperta. */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return
    return acquireBodyScrollLock()
  }, [locked])
}
